import { request } from "@/services/network";

export async function getUserDailyActivity(username) {
	return request({
		url: `/auth/users/${encodeURIComponent(username)}/daily-activity/`,
		method: "GET",
	}).then((data) => {
		return {
			activity: data,
		};
	});
}
